import { Injectable } from '@angular/core';
import { AuthService } from '@examsoft/es-login';

declare var newrelic: any;

@Injectable()
export class TrackingService {

  private data = {};

  constructor(
    public authService: AuthService
  ){
  }

  ready(esId: string, username: string, label: string, obj: any){
    this.data = { esId, username };
    this.addPageAction(label, obj);
  }

  private getData(data){
    return { ...this.data, ...data };
  }

  addPageAction(name: string, obj: any){
    newrelic.addPageAction(name, this.getData(obj) );
  }
}
